import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CanonicalService {
    private readonly siteUrl = 'https://www.albcode.de';

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(LOCALE_ID) private localeId: string
    ) { }

    setCanonicalURL(url?: string): void {
        const locale = this.localeId.startsWith('en') ? 'en' : 'de';
        const path = this.normalizeInternalPath(url);
        const canonicalUrl = this.localizedUrl(locale, path);

        this.upsertLink('canonical', undefined, canonicalUrl);
        this.upsertLink('alternate', 'de', this.localizedUrl('de', path));
        this.upsertLink('alternate', 'en', this.localizedUrl('en', path));
        this.upsertLink('alternate', 'x-default', this.localizedUrl('de', path));
    }

    private localizedUrl(locale: 'de' | 'en', path: string): string {
        if (locale === 'de') return `${this.siteUrl}${path}`;
        return `${this.siteUrl}/en${path === '/' ? '/' : path}`;
    }

    private normalizeInternalPath(url?: string): string {
        const rawPath = (url ?? '/').split(/[?#]/, 1)[0] || '/';
        const withoutLocale = rawPath.replace(/^\/(de|en)(?=\/|$)/, '') || '/';
        return withoutLocale.startsWith('/') ? withoutLocale : `/${withoutLocale}`;
    }

    private upsertLink(rel: string, hreflang: string | undefined, href: string): void {
        const selector = hreflang
            ? `link[rel='${rel}'][hreflang='${hreflang}']`
            : `link[rel='${rel}']:not([hreflang])`;
        let link = this.document.head.querySelector<HTMLLinkElement>(selector);
        if (!link) {
            link = this.document.createElement('link');
            link.rel = rel;
            if (hreflang) link.hreflang = hreflang;
            this.document.head.appendChild(link);
        }
        link.href = href;
    }
}
